import styled from 'styled-components';
import { Base, Theme } from 'styled';
import { Color } from 'styled/theme/colors';

type ContainerProps = {
  bgColor: Color;
};

export const Container = styled(Base)<ContainerProps>`
  background-color: ${({ bgColor, theme }) => theme.colors[bgColor]};
  width: ${({ theme }) =>
    `calc(100% + ${theme.sizes.carouselMobilePadding} * 2)`};
  margin: ${({ theme }) => `calc(${theme.sizes.carouselMobilePadding} * -1)`};
  margin-top: 1rem;
  padding: ${({ theme }) => theme.sizes.carouselMobilePadding};

  ${Theme.mediaQueries.md} {
    width: ${({ theme }) =>
      `calc(100% + ${theme.sizes.carouselDesktopPadding} * 2)`};
    margin: ${({ theme }) =>
      `calc(${theme.sizes.carouselDesktopPadding} * -1)`};
    margin-top: 1rem;
    padding: ${({ theme }) => theme.sizes.carouselDesktopPadding};
  }
`;

export const Description = styled.span`
  display: block;
  ${({ theme }) => theme.typography.variants.secondary.sm};
`;

export const ButtonContainer = styled(Base)`
  display: inline-flex;
`;
